import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { TableCell, TableRow } from "@material-ui/core";
import format from "date-fns/format";
import { useTranslation } from "react-i18next";
import de from "date-fns/locale/de";

const translationPath = "flokk_tickets";

const useTicketRowStyles = makeStyles((theme) => ({
  row: {
    "& > *": {
      color: ({ color }) => color || "#000",
    },
  },
}));

const TicketRow = ({ row }) => {
  const classes = useTicketRowStyles({
    color: row.color,
  });
  const { t } = useTranslation();

  return (
    <TableRow key={row.id} className={row.color ? classes.row : ""}>
      <TableCell component="th" scope="row">
        {format(new Date(row.entry_date + "Z"), "P, p", { locale: de })}
      </TableCell>
      <TableCell component="th" scope="row">
        {row.trader_contact_person_id_short_name}
      </TableCell>
      <TableCell component="th" scope="row">
        {row.id_number}
      </TableCell>
      <TableCell component="th" scope="row">
        {row.servicerequest_no}
      </TableCell>
      <TableCell component="th" scope="row">
        {row.service_address}
      </TableCell>
      <TableCell component="th" scope="row">
        {row.ticket_no}
      </TableCell>
      <TableCell component="th" scope="row">
        {row.brand_id_short_name}
      </TableCell>
      <TableCell component="th" scope="row">
        {row.model}
      </TableCell>
      <TableCell component="th" scope="row">
        {row.no_of_items}
      </TableCell>
      <TableCell component="th" scope="row">
        {row.order_number}
      </TableCell>
      <TableCell component="th" scope="row">
        {row.prod_year}
      </TableCell>
      <TableCell component="th" scope="row">
        {row.defect_desc}
      </TableCell>
      <TableCell component="th" scope="row">
        {t(translationPath + ".stage.options." + row.stage)}
      </TableCell>
    </TableRow>
  );
};

export default TicketRow;
